import { render, staticRenderFns } from "./nofooterAppLayout.vue?vue&type=template&id=4c62bc5c&"
import script from "./nofooterAppLayout.vue?vue&type=script&lang=js&"
export * from "./nofooterAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./nofooterAppLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports